import React from 'react';
import { MessageFormatElement } from 'react-intl';
import config from 'src/constants';
import { localStore } from 'src/services/storage';

interface IIntlContextState {
    locale: string;
    messages?: Record<string, string> | Record<string, MessageFormatElement[]>;
    alreadySwitched: boolean;
    isFormal: boolean;
    setLocale: (locale: string, isFormal?: boolean) => void;
}

export const defaultValues: IIntlContextState = {
    locale: localStore.getItem('locale') || config.DEFAULT_LOCALE,
    messages: {},
    alreadySwitched: !!localStore.getItem('localeSwitchedByUser') || false,
    isFormal: !!localStore.getItem('isFormalLocale') || false,
    setLocale: (_locale: string, _isFormal: boolean) => {
        throw new Error('setLocale method needs to be implemented');
    },
};

export const IntlContext = React.createContext<IIntlContextState>(defaultValues);
